module.exports = __webpack_public_path__ + "img/rebit_logo.1f84a04f.jpg";